// API Configuration
// Production Render backend URL
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://description-908s.onrender.com';

// For local development, you can override this with:
// REACT_APP_API_URL=http://localhost:5050 